import { styled } from '@ad-lucy/styled';

export const StyledMediaControlsIcon = styled.svg`
  cursor: pointer;
  filter: drop-shadow(0 1px 2px rgba(50, 48, 48, 0.8));
`;
